"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toAuditorMobileRuleId = toAuditorMobileRuleId;
const accessibility_standards_1 = require("@deque/accessibility-standards");
/**
 * Mobile SDK rule class names → the rule slugs axe Auditor imports. Auditor
 * skips any issue whose `ruleId` it doesn't recognise, and it only knows the
 * slugs.
 */
const MOBILE_RULE_ID_TO_AUDITOR_RULE_ID = new Map([...Object.values(accessibility_standards_1.iosRules), ...Object.values(accessibility_standards_1.androidRules)].flatMap(({ sdkRuleId, legacySdkRuleIds = [], auditorRuleId }) => auditorRuleId
    ? [sdkRuleId, ...legacySdkRuleIds].map(id => [id, auditorRuleId])
    : []));
function toAuditorMobileRuleId(ruleId) {
    return MOBILE_RULE_ID_TO_AUDITOR_RULE_ID.get(ruleId) ?? ruleId;
}
//# sourceMappingURL=auditorRuleIds.js.map